/* Cyrus theme script: age check, header, reveals, hero, rails, cards, filters, product page and basket. No dependencies (Lenis is optional). */
(function () {
  'use strict';
  var C = window.CYRUS || {};
  var doc = document, html = doc.documentElement;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || C.root || '/';
  var lenis = null;

  function $(s, el) { return (el || doc).querySelector(s); }
  function $$(s, el) { return Array.prototype.slice.call((el || doc).querySelectorAll(s)); }
  function store(key, val) { try { if (val === undefined) return localStorage.getItem(key); localStorage.setItem(key, val); } catch (e) {} return null; }
  var fmt; try { fmt = new Intl.NumberFormat(C.locale || 'en-GB', { style: 'currency', currency: C.currency || 'GBP' }); } catch (e) {}
  function money(c) { var v = (Number(c) || 0) / 100; return fmt ? fmt.format(v) : '£' + v.toFixed(2); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  window.CYRUS_JS = true;
  if (!reduce) html.classList.add('motion');

  /* ---------- smooth scroll ---------- */
  if (!reduce && window.Lenis) {
    try {
      lenis = new window.Lenis({ lerp: 0.11, smoothWheel: true });
      (function raf(t) { lenis.raf(t); requestAnimationFrame(raf); })(performance.now());
    } catch (e) { lenis = null; }
  }
  function lock(on) {
    if (lenis) { if (on) lenis.stop(); else lenis.start(); }
    doc.body.style.overflow = on ? 'hidden' : '';
  }
  function scrollTo(el) {
    if (!el) return;
    if (lenis) lenis.scrollTo(el, { offset: -100, duration: 1.2 });
    else el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }

  /* ---------- age check ---------- */
  function initGate() {
    var gate = $('#gate'); if (!gate) return;
    if (html.classList.contains('age-ok')) return;
    var yes = $('#gateYes'), no = $('#gateNo');
    setTimeout(function () { if (yes) yes.focus({ preventScroll: true }); }, 50);
    yes.addEventListener('click', function () {
      store('cyrus-age', '1');
      gate.classList.add('is-out');
      setTimeout(function () { html.classList.add('age-ok'); }, 600);
    });
    no.addEventListener('click', function () { $('#gateNoMsg').hidden = false; });
  }

  /* ---------- header + menu ---------- */
  function initHeader() {
    var hdr = $('#hdr'); if (!hdr) return;
    var last = 0, ticking = false;
    function update() {
      var y = window.scrollY;
      hdr.classList.toggle('is-scrolled', y > 24 || C.template !== 'index');
      if (!doc.body.classList.contains('menu-open')) hdr.classList.toggle('is-hidden', y > 320 && y > last + 2);
      if (y < last - 2) hdr.classList.remove('is-hidden');
      last = y; ticking = false;
    }
    addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    var btn = $('#menuBtn'), menu = $('#menu');
    function setMenu(open) {
      doc.body.classList.toggle('menu-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      menu.setAttribute('aria-hidden', open ? 'false' : 'true');
      lock(open);
    }
    if (btn && menu) {
      btn.addEventListener('click', function () { setMenu(!doc.body.classList.contains('menu-open')); });
      $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
      addEventListener('keydown', function (e) { if (e.key === 'Escape' && doc.body.classList.contains('menu-open')) setMenu(false); });
    }
  }

  /* ---------- text lines + reveals ---------- */
  function splitLines(el) {
    if (el.__split) return; el.__split = true;
    var i = 0;
    function walk(node) {
      if (node.nodeType === 3) {
        var frag = doc.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach(function (part) {
          if (!part) return;
          if (/^\s+$/.test(part)) { frag.appendChild(doc.createTextNode(' ')); return; }
          var o = doc.createElement('span'); o.className = 'ln';
          var n = doc.createElement('span'); n.textContent = part; n.style.setProperty('--i', i++);
          o.appendChild(n); frag.appendChild(o);
        });
        node.parentNode.replaceChild(frag, node);
      } else if (node.nodeType === 1) Array.prototype.slice.call(node.childNodes).forEach(walk);
    }
    Array.prototype.slice.call(el.childNodes).forEach(walk);
  }
  function initReveal() {
    var els = $$('[data-reveal], [data-lines]');
    els.forEach(function (el) { if (el.hasAttribute('data-lines')) splitLines(el); });
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
    // anything already on screen reveals right away
    requestAnimationFrame(function () {
      els.forEach(function (el) { var r = el.getBoundingClientRect(); if (r.top < innerHeight * 0.95 && r.bottom > 0) el.classList.add('is-in'); });
    });
  }

  /* ---------- hero ---------- */
  function initHero() {
    var hero = $('#hero'), box = $('[data-hero]'); if (!hero || !box) return;
    var slides = $$('[data-slide]', box), infos = $$('[data-info]', box), dots = $$('[data-dot]', box);
    if (!slides.length) return;
    var cur = 0, timer = null, DUR = 6000, paused = false;
    hero.style.setProperty('--dur', DUR + 'ms');
    function go(n) {
      if (n === cur) return;
      var prev = cur; cur = (n + slides.length) % slides.length;
      slides[prev].classList.remove('is-on'); slides[prev].classList.add('is-out'); slides[prev].setAttribute('tabindex', '-1');
      setTimeout(function () { slides[prev].classList.remove('is-out'); }, 900);
      slides[cur].classList.add('is-on'); slides[cur].removeAttribute('tabindex');
      infos.forEach(function (x, i) { x.classList.toggle('is-on', i === cur); });
      dots.forEach(function (d, i) {
        d.classList.remove('is-on'); d.setAttribute('aria-selected', i === cur ? 'true' : 'false');
        if (i === cur) { void d.offsetWidth; d.classList.add('is-on'); }
      });
      hero.style.setProperty('--hero-tint', slides[cur].getAttribute('data-tint'));
      schedule();
    }
    function schedule() { clearTimeout(timer); if (!reduce && !paused) timer = setTimeout(function () { go(cur + 1); }, DUR); }
    function pause(on) { paused = on; hero.classList.toggle('is-paused', on); if (on) clearTimeout(timer); else schedule(); }
    hero.style.setProperty('--hero-tint', slides[0].getAttribute('data-tint'));
    dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
    box.addEventListener('mouseenter', function () { pause(true); });
    box.addEventListener('mouseleave', function () { pause(false); });
    box.addEventListener('focusin', function () { pause(true); });
    box.addEventListener('focusout', function () { pause(false); });
    doc.addEventListener('visibilitychange', function () { pause(doc.hidden); });
    var sx = null;
    box.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; sx = null;
      if (Math.abs(dx) > 40) go(cur + (dx < 0 ? 1 : -1));
    });
    if (reduce) dots.forEach(function (d) { d.classList.remove('is-on'); });
    schedule();
  }

  /* ---------- rails ---------- */
  function initRails() {
    $$('[data-rail]').forEach(function (rail) {
      var sec = rail.closest('section');
      var prev = sec && $('[data-rail-prev]', sec), next = sec && $('[data-rail-next]', sec);
      function step() { var c = rail.querySelector('.card'); return c ? c.getBoundingClientRect().width + 22 : 300; }
      function state() {
        if (!prev || !next) return;
        prev.disabled = rail.scrollLeft < 8;
        next.disabled = rail.scrollLeft + rail.clientWidth > rail.scrollWidth - 8;
      }
      if (prev) prev.addEventListener('click', function () { rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { rail.scrollBy({ left: step(), behavior: 'smooth' }); });
      rail.addEventListener('scroll', state, { passive: true });
      addEventListener('resize', state);
      state();
      // mouse drag
      var down = false, x0 = 0, s0 = 0, moved = 0;
      rail.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'mouse') return; down = true; moved = 0; x0 = e.clientX; s0 = rail.scrollLeft; });
      addEventListener('pointermove', function (e) { if (!down) return; var dx = e.clientX - x0; moved = Math.max(moved, Math.abs(dx)); if (moved > 4) { rail.style.scrollSnapType = 'none'; rail.scrollLeft = s0 - dx; } });
      addEventListener('pointerup', function () { if (!down) return; down = false; rail.style.scrollSnapType = ''; });
      rail.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true);
      rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    });
  }

  /* ---------- cards + sizes ---------- */
  function setPrice(el, text) {
    if (!el || el.textContent === text) return;
    el.textContent = text; el.classList.remove('is-changing'); void el.offsetWidth; el.classList.add('is-changing');
  }
  function swapImage(card, src) {
    var img = $('.stage-img', card); if (!img || !src) return;
    if (img.getAttribute('src') === src) return;
    var pre = new Image(); pre.onload = function () {
      img.style.opacity = 0;
      setTimeout(function () { img.removeAttribute('srcset'); img.src = src; img.style.opacity = ''; }, 220);
    }; pre.src = src;
  }
  function choose(card, btn) {
    $$('[data-size-btn]', card).forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
    card.setAttribute('data-rep', btn.getAttribute('data-id'));
    setPrice($('[data-price-el]', card), money(btn.getAttribute('data-price')));
    var url = btn.getAttribute('data-url');
    $$('[data-card-link]', card).forEach(function (a) { a.setAttribute('href', url); });
    var add = $('[data-add]', card), ok = btn.getAttribute('data-avail') === 'true';
    if (add) {
      add.disabled = !ok;
      var t = $('.add-t', add); if (t) t.textContent = ok ? (card.hasAttribute('data-pdp') ? 'Add to basket' : 'Add') : 'Sold out';
    }
    swapImage(card, btn.getAttribute('data-img'));
    if (card.hasAttribute('data-pdp')) {
      $$('[data-size-label]', card).forEach(function (l) { l.textContent = btn.getAttribute('data-size'); });
      try { history.replaceState(null, '', url); } catch (e) {}
    }
  }
  function initCards(scope) {
    $$('[data-card]', scope).forEach(function (card) {
      if (card.__on) return; card.__on = true;
      var rep = card.getAttribute('data-rep');
      $$('[data-size-btn]', card).forEach(function (b) {
        if (!card.hasAttribute('data-pdp')) b.setAttribute('aria-pressed', b.getAttribute('data-id') === rep ? 'true' : 'false');
        b.addEventListener('click', function () { choose(card, b); });
      });
      var add = $('[data-add]', card);
      if (add) add.addEventListener('click', function () {
        var q = $('[data-qty-n]', card); addToCart(card.getAttribute('data-rep'), q ? parseInt(q.textContent, 10) || 1 : 1, add);
      });
    });
  }

  /* ---------- filters + sort ---------- */
  var applyHash = function () {};
  function initFilters() {
    var tabs = $('[data-tabs]'), grid = $('[data-grid]');
    if (!grid) return;
    var cards = $$('.card', grid), order = cards.slice(), countEl = $('[data-count]'), sortEl = $('[data-sort]');
    var ink = tabs && $('.tab-ink', tabs), current = 'all';
    function moveInk() {
      if (!tabs || !ink) return;
      var on = $('.tab.is-on', tabs); if (!on) return;
      ink.style.width = on.offsetWidth + 'px';
      ink.style.transform = 'translateX(' + on.offsetLeft + 'px)';
    }
    function counts() { if (countEl) { var n = cards.filter(function (c) { return !c.classList.contains('is-gone'); }).length; countEl.textContent = n + (n === 1 ? ' product' : ' products'); } }
    var hideT = 0;
    function apply(f, animate) {
      current = f; clearTimeout(hideT);
      if (tabs) $$('[data-filter]', tabs).forEach(function (t) { var on = t.getAttribute('data-filter') === f; t.classList.toggle('is-on', on); t.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      moveInk();
      var lim = +(grid.getAttribute('data-limit') || 0), more = $('[data-more]');
      var show = function (c) { return f === 'all' ? (!lim || order.indexOf(c) < lim) : c.getAttribute('data-type') === f; };
      if (more) more.hidden = f !== 'all';
      if (!animate || reduce) { cards.forEach(function (c) { c.classList.remove('is-hiding'); c.style.transitionDelay = ''; c.classList.toggle('is-gone', !show(c)); }); counts(); return; }
      cards.forEach(function (c) { if (!c.classList.contains('is-gone')) c.classList.add('is-hiding'); });
      hideT = setTimeout(function () {
        cards.forEach(function (c) { var on = show(c); c.classList.toggle('is-gone', !on); c.classList.toggle('is-hiding', on); });
        var vis = cards.filter(function (c) { return !c.classList.contains('is-gone'); });
        vis.forEach(function (c, i) { c.style.transitionDelay = Math.min(i * 40, 400) + 'ms'; });
        void grid.offsetWidth;
        hideT = setTimeout(function () { vis.forEach(function (c) { c.classList.remove('is-hiding'); }); }, 30);
        setTimeout(function () { vis.forEach(function (c) { c.style.transitionDelay = ''; if (!c.classList.contains('is-gone') && current === f) c.classList.remove('is-hiding'); }); }, 1000);
        counts();
      }, 260);
    }
    if (tabs) $$('[data-filter]', tabs).forEach(function (t) {
      t.addEventListener('click', function () {
        var f = t.getAttribute('data-filter'); if (f === current) return;
        apply(f, true);
        try { history.replaceState(null, '', f === 'all' ? location.pathname + location.search : '#' + f); } catch (e) {}
      });
    });
    if (sortEl) sortEl.addEventListener('change', function () {
      var v = sortEl.value, list = order.slice();
      if (v === 'low') list.sort(function (a, b) { return a.getAttribute('data-price') - b.getAttribute('data-price'); });
      if (v === 'high') list.sort(function (a, b) { return b.getAttribute('data-price') - a.getAttribute('data-price'); });
      grid.style.opacity = 0;
      setTimeout(function () { list.forEach(function (c) { grid.appendChild(c); }); grid.style.opacity = ''; }, 200);
    });
    grid.style.transition = 'opacity .3s ease';
    applyHash = function (fromLink) {
      var h = (location.hash || '').slice(1);
      var ok = tabs && $$('[data-filter]', tabs).some(function (t) { return t.getAttribute('data-filter') === h; });
      apply(ok ? h : 'all', fromLink === true);
      if (ok && (C.template === 'index' || fromLink === true)) scrollTo($('#range') || grid.closest('section'));
    };
    addEventListener('hashchange', function () { applyHash(true); });
    addEventListener('resize', moveInk);
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(moveInk);
    applyHash();
  }

  /* ---------- product page ---------- */
  function initPdp() {
    var pdp = $('[data-pdp]'); if (!pdp) return;
    var q = $('[data-qty]', pdp);
    if (q) {
      var n = $('[data-qty-n]', q);
      $$('[data-step]', q).forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.min(99, Math.max(1, (parseInt(n.textContent, 10) || 1) + parseInt(b.getAttribute('data-step'), 10)));
          setPrice(n, String(v));
        });
      });
    }
    // smooth accordions
    $$('.acc-i', pdp).forEach(function (d) {
      var s = $('summary', d), b = $('.acc-b', d);
      s.addEventListener('click', function (e) {
        if (reduce || !b.animate) return;
        e.preventDefault();
        if (d.open) {
          var h = b.offsetHeight;
          b.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' }).onfinish = function () { d.open = false; };
        } else {
          d.open = true; var h2 = b.offsetHeight;
          b.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  }

  /* ---------- basket ---------- */
  var drawer = $('#drawer'), scrim = $('#scrim'), body = $('#drawerBody'), lastFocus = null, isOpen = false, lastAdded = null;
  function api(path, data) {
    var o = { headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin' };
    if (data) { o.method = 'POST'; o.body = JSON.stringify(data); }
    return fetch(ROOT + path, o).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.'); return j; }); });
  }
  function sized(u, w) { return u ? u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w : ''; }
  function tintFor(id) { var b = $('[data-size-btn][data-id="' + id + '"]'); var s = b && b.closest('[data-card]'); var st = s && $('.stage', s); return st ? st.style.getPropertyValue('--tint') : ''; }
  function setCount(n, bump) {
    var c = $('#cartCount'); if (!c) return;
    c.textContent = n; c.classList.toggle('on', n > 0);
    if (bump) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); }
    var d = $('#drawerCount'); if (d) d.textContent = n ? '(' + n + ')' : '';
  }
  function render(cart, bump) {
    setCount(cart.item_count, bump);
    var sub = $('#drawerSub'); if (sub) sub.textContent = money(cart.total_price);
    var ft = $('#drawerFt'); if (ft) ft.hidden = !cart.item_count;
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="drawer-empty"><b>Your basket is empty</b><p>Find something worth raising a glass to.</p><a class="btn btn-gold" href="' + esc(C.collection || '/collections/all') + '">Shop the cellar</a></div>';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var parts = (it.product_title || '').split(' · ');
      var tint = tintFor(it.variant_id) || '#3a2410';
      return '<div class="dl' + (String(it.variant_id) === String(lastAdded) ? ' is-new' : '') + '" data-key="' + esc(it.key) + '" data-q="' + it.quantity + '">' +
        '<a class="dl-media" href="' + esc(it.url) + '"><span class="stage" style="--tint:' + esc(tint) + '"><span class="stage-glow"></span>' + (it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</span></a>' +
        '<div><a class="dl-t" href="' + esc(it.url) + '">' + esc(parts[0]) + '</a>' + (parts[1] ? '<span class="dl-s">' + esc(parts.slice(1).join(' · ')) + '</span>' : '') +
        '<div class="dl-q"><button type="button" data-d="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-d="1" aria-label="Increase quantity">+</button></div></div>' +
        '<div class="dl-r"><span class="dl-p">' + money(it.final_line_price) + '</span><button class="dl-rm" type="button" data-rm>Remove</button></div></div>';
    }).join('');
    lastAdded = null;
    $$('.dl', body).forEach(function (row) {
      var key = row.getAttribute('data-key'), q = parseInt(row.getAttribute('data-q'), 10);
      $$('[data-d]', row).forEach(function (b) { b.addEventListener('click', function () { change(row, key, q + parseInt(b.getAttribute('data-d'), 10)); }); });
      $('[data-rm]', row).addEventListener('click', function () { change(row, key, 0); });
    });
  }
  function change(row, key, qty) {
    row.style.pointerEvents = 'none';
    if (qty <= 0) row.classList.add('is-leaving'); else row.style.opacity = '.55';
    setTimeout(function () {
      api('cart/change.js', { id: key, quantity: Math.max(0, qty) }).then(function (c) { render(c); }).catch(function (e) { toast(e.message); refresh(); });
    }, qty <= 0 ? 350 : 0);
  }
  function refresh() { return api('cart.js').then(function (c) { render(c); }).catch(function () {}); }
  function openCart() {
    if (!drawer || isOpen) return; isOpen = true; lastFocus = doc.activeElement;
    scrim.hidden = false; requestAnimationFrame(function () { scrim.classList.add('is-on'); });
    drawer.classList.add('is-on'); drawer.setAttribute('aria-hidden', 'false'); lock(true);
    setTimeout(function () { drawer.focus({ preventScroll: true }); }, 80);
  }
  function closeCart() {
    if (!drawer || !isOpen) return; isOpen = false;
    scrim.classList.remove('is-on'); setTimeout(function () { scrim.hidden = true; }, 500);
    drawer.classList.remove('is-on'); drawer.setAttribute('aria-hidden', 'true'); lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  var tt;
  function toast(msg) {
    var t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('is-on'); clearTimeout(tt);
    tt = setTimeout(function () { t.classList.remove('is-on'); }, 2800);
  }
  function addToCart(id, qty, btn) {
    if (!id || (btn && btn.disabled)) return;
    if (btn) btn.classList.add('is-busy');
    api('cart/add.js', { items: [{ id: Number(id), quantity: qty || 1 }] }).then(function () {
      lastAdded = id;
      if (btn) { btn.classList.remove('is-busy'); btn.classList.add('is-done'); setTimeout(function () { btn.classList.remove('is-done'); }, 1600); }
      return api('cart.js').then(function (c) { render(c, true); setTimeout(openCart, 350); });
    }).catch(function (e) { if (btn) btn.classList.remove('is-busy'); toast(e.message); });
  }
  function initCart() {
    var o = $('#cartOpen'), x = $('#cartClose');
    if (o) o.addEventListener('click', function () { if (C.template === 'cart') return; openCart(); });
    if (x) x.addEventListener('click', closeCart);
    if (scrim) scrim.addEventListener('click', closeCart);
    addEventListener('keydown', function (e) { if (e.key === 'Escape') closeCart(); });
    if (drawer) drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$('a[href], button:not([disabled])', drawer); if (!f.length) return;
      if (e.shiftKey && doc.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && doc.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });
    refresh();
  }

  /* ---------- same-page anchors use smooth scroll ---------- */
  function initAnchors() {
    doc.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href*="#"]'); if (!a) return;
      var url; try { url = new URL(a.href, location.href); } catch (err) { return; }
      if (url.pathname !== location.pathname || !url.hash) return;
      var t = doc.getElementById(url.hash.slice(1));
      if (t) { e.preventDefault(); scrollTo(t); try { history.replaceState(null, '', url.hash); } catch (err) {} }
    });
  }

  function boot() {
    initGate(); initHeader(); initReveal(); initHero(); initRails(); initCards(doc);
    initFilters(); initPdp(); initCart(); initAnchors();
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();
})();
